import { render, staticRenderFns } from "./activity-timeline.vue?vue&type=template&id=babd352e&scoped=true"
import script from "./activity-timeline.vue?vue&type=script&setup=true&lang=js"
export * from "./activity-timeline.vue?vue&type=script&setup=true&lang=js"
import style0 from "./activity-timeline.vue?vue&type=style&index=0&id=babd352e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babd352e",
  null
  
)

export default component.exports